import React, { useState } from 'react';
import axios from 'axios';
import contactDev from '../../assets/contact-dev.png';
import Swal from 'sweetalert2';

const ContactPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const username = JSON.parse(localStorage.getItem('uname'));
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    const URL = `https://stucharge.bakersbrisk.com/api/contactformapi`;

    let bodyFormData = new FormData();
    bodyFormData.append('name', name);
    bodyFormData.append('email', email);
    bodyFormData.append('message', message);
    bodyFormData.append('username', username);
    // making post request
    axios
      .post(URL, bodyFormData, {
        headers: { Authorization: AuthStr },
      })
      .then(function (response) {
        if (response.status === 201) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'We will contact you soon!',
            showConfirmButton: false,
            timer: 1800,
          });
          setName('');
          setEmail('');
          setMessage('');
        }
      })
      .catch((error) => {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Cannot process request at the moment',
          showConfirmButton: false,
          timer: 1400,
        });
      });
  };

  return (
    <main>
      <div
        className='main_container'
        style={{ paddingBottom: '0', marginBottom: '0' }}
      >
        <div className='main_title'>
          <img src={contactDev} alt='contact-dev' />
          <div className='main_greeting'>
            <h1>Contact Developer </h1>
            <p>Feel free to contact Developer</p>
          </div>
        </div>

        <form className='class-form' onSubmit={handleSubmit}>
          <div className='form-control'>
            <label htmlFor='name'>Your Name*</label>
            <input
              type='text'
              required
              value={name}
              placeholder='Enter name'
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className='form-control'>
            <label htmlFor='email'>Your Email*</label>
            <input
              type='email'
              required
              value={email}
              placeholder='Enter email'
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className='form-control'>
            <label htmlFor='message'>Message*</label>
            <textarea
              required
              placeholder='Message'
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button type='submit' className='btn'>
            Submit
          </button>
        </form>

        <div className='main_cards contact'>
          <div className='card'>
            <div className='card_inner'>
              <a
                href='http://instagram.com/itsnamanmalik/'
                target='_blank'
                rel='noopener noreferrer'
              >
                <i className='fab fa-instagram text-red	fa-2x'></i>
              </a>
            </div>
          </div>

          <div className='card'>
            <div className='card_inner'>
              <a
                href='https://wa.me/918077344267'
                target='_blank'
                rel='noopener noreferrer'
              >
                <i className='fab fa-whatsapp  text-green fa-2x'></i>
              </a>
            </div>
          </div>
          <div className='card'>
            <div className='card_inner'>
              <a
                href='mailto:codvensolutions@gmail.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                <i className='fas fa-envelope-square  text-blue fa-2x'></i>
              </a>
            </div>
          </div>

          <div className='card'>
            <div className='card_inner'>
              <a
                href='tel:8077344267'
                target='_blank'
                rel='noopener noreferrer'
              >
                <i className='fas fa-phone  text-lightblue fa-2x'></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ContactPage;
